module.exports = __webpack_public_path__ + "static/media/LogoAlt.3744224c.png";